export default {
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
  REACT_APP_ADMIN_URL: process.env.REACT_APP_ADMIN_URL,
  REACT_APP_JF_LOGO: process.env.REACT_APP_JF_LOGO,
  REACT_S3_URL: process.env.REACT_S3_URL,
  ENABLE_REDUX_LOGGER: process.env.ENABLE_REDUX_LOGGER === 'true',
};
